import { Entity } from "../../types/store.types";
import { FlaggersMethods } from "./flaggers.methods";

export type FlaggersState<T extends Object> = T;

export interface IReducerAction {
  type: FlaggersMethods;
  payload?: {
    entities?: Entity<any>;
  };
}

let initialState: FlaggersState<any> = null;

export const flaggersReducer = 
<TAction extends IReducerAction>(
  state = initialState, action: TAction, entityName: string
) => {
  switch(action.type) {
    case FlaggersMethods.UpdateFlagger: {
      if (!action.payload || !action.payload.entities) break;
      const entities = action.payload.entities;
      if (!(entityName in entities)) break;
      state = entities[entityName];
      break;
    }
    case FlaggersMethods.ResetFlagger: {
      if (!action.payload || !action.payload.entities) break;
      const entities = action.payload.entities;
      if (!(entityName in entities)) break;
      state = {};
      break;
    }
  }
  return state;
}
